import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=3522e67e&scoped=true&"
import script from "./storage.vue?vue&type=script&lang=ts&"
export * from "./storage.vue?vue&type=script&lang=ts&"
import style0 from "./storage.vue?vue&type=style&index=0&id=3522e67e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3522e67e",
  null
  
)

export default component.exports